import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setSideEffects } from '../../redux/userSlice';
import Question from "../../components/Question";
import ContinueButton from "../../components/ContinueButton";
import { textAreaSx } from "../../lib/uiformatting";
import { Box, FormControl, TextField } from "@mui/material";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function DescribeSideEffects() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { sideEffects } = useSelector((state) => state.user);
    const [localSideEffects, setLocalSideEffects] = useState(sideEffects.description || "");

    const handleNext = () => {
        dispatch(setSideEffects({ has: "Yes", description: localSideEffects }));
        setPageAndDeferNavigate(dispatch, '/follow-up-care', () =>
            navigate('/follow-up-care', { state: { returning: true } })
        );
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/stop-medication-reason', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            returning={true}
            title="We are so sorry about the side effects. Can you describe them below?"
            input={
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <FormControl sx={{ width: "100%", mb: "2rem" }} required>
                        <TextField
                            placeholder="Answer here..."
                            variant="outlined"
                            color="secondary"
                            sx={{ ...textAreaSx, width: "100%" }}
                            autoComplete="off"
                            multiline
                            rows={5}
                            value={localSideEffects}
                            onChange={(e) => setLocalSideEffects(e.target.value)}
                        />
                    </FormControl>
                    <ContinueButton
                        onClick={handleNext}
                        title="Continue"
                        disabled={!localSideEffects}
                        selected={localSideEffects}
                    />
                </Box>
            }
        />
    );
}
